<template>
    <div v-if="!canChangeDeliverableType" class="data-items" :class="classNames">
        <span>
            {{ deliverableTypeTitle(deliverable.deliverable_template_id) || 'Unknown Type' }}
        </span>
    </div>
    <div v-else class="data-items deliverable-type-link" data-toggle="dropdown" :class="classNames">
        <span>
            {{ deliverableTypeTitle(deliverable.deliverable_template_id) || 'Unknown Type' }}
        </span>
        <div class="dropdown-menu">
            <a class="dropdown-item" href="#" v-for="(type, i) in deliverableTypes" :key="i"
                @click.prevent="changeDeliverableType(deliverable, type)">{{ type.name }}</a>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: ["classNames", "deliverable", "deliverableTypes"],
    computed: {
        ...mapGetters([
			"allDeliverableTypes",
		]),
        canChangeDeliverableType() {
            return false;
            /*
            * Changing deliverable type not needed now
            if (this.$router.currentRoute.name == 'mediaCallPage' || this.deliverableTypes.length < 2) {
                return false;
            } else {
                return true;
            }
            */
        },
    },
    methods: {
        deliverableTypeTitle(deliverableTypeId) {
            if (this.deliverableTypes && deliverableTypeId) {
                let typeData = _.filter(this.deliverableTypes, { typeId: deliverableTypeId });
                if (typeData.length > 0) {
                    return typeData[0].name;
                }
            }
            if (this.allDeliverableTypes && deliverableTypeId) {
                let typeData = _.filter(this.allDeliverableTypes, { typeId: deliverableTypeId });
                if (typeData.length > 0) {
                    return typeData[0].name;
                }
            }
            return null;
        },
        changeDeliverableType(deliverable, type) {
            if (deliverable.deliverable_template_id == type.typeId) return;
            this.$store.dispatch('changeDeliverableType', {
                id: deliverable.id,
                deliverable_type: type.id,
                old_deliverable_template_id: deliverable.deliverable_template_id,
            }).then(r => {
                this.$store.dispatch('manageUndoActivation', 'Deliverable type changed.');
            });
        },

    },
}
</script>